import { memo } from 'react';
import { ForgotPasswordUpdateTemplate } from 'components/templates/ForgotPasswordUpdateTemplate';

type Props = {};

export const ForgotPasswordUpdatePage = memo((_props: Props) => {
	return <ForgotPasswordUpdateTemplate />;
});
